// See http://hammerjs.github.io/tips/
delete Hammer.defaults.cssProps.userSelect;
